import React from 'react'
import { useShared } from '../../../hooks/useShared'
import AMenu from '../../../components/partials/AMenu';
import MainSection from '../../../components/sections/MainSection';

const TABLE_HEAD = ["#", "ای دی", "نام", "ملاحظات", 'ايجاد کننده', 'تاريخ ايجاد', 'اقدامات'];
const breadcrumbs = [{ name: 'کاربران', link: '/users/usrs' }, { name: 'نقش‌ها کاربر', link: '/user_roles' }]
const menuData = [
  {flag: 'Edit', name: 'Edit', icon: 'create-outline', roles: [1, 2] },
  { flag: 'Delete', name: 'Delete', icon: 'trash-outline', roles: [1] },
]

const searchInputFields = [
  { label: 'نام', name: 'name', type: 'text', roles: [1], icon: 'person', className: 'md:col-span-3' },
  { label: 'ملاحظات', name: 'description', type: 'text', roles: [1], icon: 'book-outline', className: 'md:col-span-3' },
];

const newModelInputFields = [
  { label: 'نام', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'The name is requieed', isStyle: false },
  { label: 'حالت', name: 'status', type: 'switch', roles: [1], icon: 'book-outline', className: '', required: false },
  { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false },

];

export default function UserRole() {

  const { com, setModel, models, setShowViewDialog, showDeleteDialog, setShowDeleteDialog, setShowNewModelDialog } = useShared();


  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)
    }
    if (flag === 'edit') {
      setModel(model)
      setShowNewModelDialog(true)
    }
    if (flag === 'view') {
      setModel(model)
      setShowViewDialog(true)
    }
  };


  const handleViewDialog = (obj) => {
    return [
      { l: ' Name', v: obj?.name },
      { l: 'Description', v: obj?.description },
      { l: 'Added by', v: obj?.user?.full_name },
      { l: 'Status', v: obj?.status },
      { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
    ]
  }

  const getTableData = () => {
    return (
      <tbody className=''>
        {models?.data?.map((r, i) => {

          return (<tr key={r.id} >
            <td >{models?.from + i}</td>
            <td >{r.id}</td>

            <td className='!p-1'> <div className='flex flex-row items-center'>
              <div className={` rounded-full h-3 w-3 mx-2 ${r.status === 1 || r.status ? 'bg-green-500' : 'bg-red-700'}`} /> {r.name}</div>
            </td>
            <td >{r.description}</td>
            <td >{r?.user?.full_name}</td>
            <td >{com.dateConvert(r?.created_at, false, true)}</td>
            <td >
              <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />

            </td>
          </tr>)
        })
        }
      </tbody>
    )
  }

  return (
    <div>

      <MainSection v={{
        handleViewDialog,
        newModelInputFields,
        searchInputFields,
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        addNewItemTitle: "نـقـش جديد",
        tableTitle: 'لیست نقش‌ها کاربر',
        mUrl: { delete: 'roles', create: 'roles', getAll: 'rolesAdvanceSearch' },

        getModelUrl: 'get_roles',
        modelScreen: 'Roles'
      }} />
    </div>
  )




}